export let ButtonProps = {
    type: {
        default: 'button'
    },
    href: {
        default: null
    },
    target: {
        default: '_self'
    }
}